import { BASE_MAX_TEAMS_VALIDATION_SHAPE } from './base-tournament-max-teams-validation.shape';
import { BASE_MIN_TEAMS_VALIDATION_SHAPE } from './base-tournament-min-teams-validation.shape';
import { HTML_CONTENT_MAX_CHARACTERS_COUNT } from '@okletsplay/core';
import { mixed, number, object, string, boolean } from 'yup';
import every from 'lodash/every';
import 'shared/validators';
import { UserBalanceValidationOptions } from 'modules/payments/validators';

export const createBaseTournamentValidationSchema = (props: UserBalanceValidationOptions) => {
  return object().shape({
    name: string().required().max(20).label('Name'),
    description: string()
      .htmlContentMaxCharactersCount(HTML_CONTENT_MAX_CHARACTERS_COUNT)
      .label('Description'),
    passphrase: string()
      .notRequired()
      .min(8)
      .nullable()
      .transform((value: string) => (!!value ? value : null))
      .label('Passphrase'),
    teamsSettings: object().shape({
      minTeams: BASE_MIN_TEAMS_VALIDATION_SHAPE,
      maxTeams: BASE_MAX_TEAMS_VALIDATION_SHAPE,
    }),
    prizeAndDistribution: object().shape({
      isDistributedExternally: boolean(),
      seedAmount: number().label('Seed Amount').userBalance(props),
      manualWeights: mixed().test({
        name: 'manualWeights',
        message: 'Ranks should be arranged in descending order.',
        test: function (data) {
          return every(
            data,
            (value: number, index: number, array: number[]) =>
              index === 0 || array[index - 1] >= value
          );
        },
      }),
    }),
  });
};
